// Context object + type + hook for VideoGenerationContext, split out of the .tsx so
// the component file only exports the VideoGenerationProvider component
// (react-refresh/only-export-components).

import { createContext, useContext } from 'react';
import type { VideoConfig } from '@/types';

export interface VideoGenerationContextValue {
  isBackendConnected: boolean | null;
  externalConfigUpdate: Partial<VideoConfig> | null | undefined;
}

export const VideoGenerationContext = createContext<VideoGenerationContextValue | null>(null);

export function useVideoGeneration(): VideoGenerationContextValue {
  const ctx = useContext(VideoGenerationContext);
  if (ctx === null) {
    throw new Error('useVideoGeneration must be used within a VideoGenerationProvider');
  }
  return ctx;
}
